import { appApi } from '../api'
import { AddInterestPeriodRequest, GetPropertyDelayedFees } from 'types/interest-periods/interest-periods-requests'
import { InterestPeriod } from 'types/interest-periods/interest-period'
import {
    DetailedInterestFeeResult,
    InterestFeeResult,
    InterestestFeeResponse,
} from 'types/delayed-interests/interest-fee-result'

const interestRatesApi = appApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllRates: builder.query<InterestPeriod[], void>({
            query: () => ({
                url: '/v1/InterestRates/all-periods',
                method: 'GET',
            }),
            providesTags: ['InterestPeriods'],
        }),

        createInterestPeriod: builder.mutation<InterestPeriod, AddInterestPeriodRequest>({
            query: (payload) => ({
                url: '/v1/InterestRates/period',
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: (result) => (result ? ['InterestPeriods'] : []),
        }),

        getPropertyDelayedFees: builder.query<InterestestFeeResponse<InterestFeeResult>, GetPropertyDelayedFees>({
            query: (payload) => ({
                url: '/v1/InterestRates/property-delayed-fees',
                params: payload,
            }),
        }),

        getPropertyDetailedDelayedFees: builder.query<
            InterestestFeeResponse<DetailedInterestFeeResult>,
            GetPropertyDelayedFees
        >({
            query: (payload) => ({
                url: '/v1/InterestRates/property-delayed-fees-detailed',
                params: payload,
            }),
        }),
    }),
})

export const {
    useGetAllRatesQuery,
    useCreateInterestPeriodMutation,
    useGetPropertyDelayedFeesQuery,
    useGetPropertyDetailedDelayedFeesQuery,
} = interestRatesApi
